import { render, staticRenderFns } from "./SummarySectionV2.vue?vue&type=template&id=e06afd42&scoped=true"
import script from "./SummarySectionV2.vue?vue&type=script&lang=js"
export * from "./SummarySectionV2.vue?vue&type=script&lang=js"
import style0 from "./SummarySectionV2.vue?vue&type=style&index=0&id=e06afd42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06afd42",
  null
  
)

export default component.exports